<template>
  <div>
    <div class="ShowCartRadiosRial1Scrollbar">
      <div>
        <div class="ShowCartRadiosRial">
          <div
            :style="`background-image: url('img/amlakLogo.jpg');`"
            class="ImageShowCartRadiosRial"
          ></div>

          <div class="ShowToUSer">
            <div class="TopShowCartRadiosRial1">
              <span> {{ $store.state.auth.nickname }} </span>
            </div>

            <div class="assetsTopShowCartRadiosRial">
              <p >{{ formatPrice($store.state.auth.credit) }}</p>
              <span>{{ $store.state.c_set.currency }}</span>
            </div>

            <p class="assetsTopShowCartRadiosRial1">موجودی کیف پول</p>
          </div>
        </div>
        <div class="ShowAmountAndCart">
          <div class="SelectMoneyShow">
            <div
            v-for="(v,i) in $store.state.c_set.wallet_defult_price"
            :key="i"
            class="ChildSelectMoneyShow"
            @click="ShowMoneyToUSer(v)"
            >
              {{ formatPrice(v) }}
            </div>
          </div>

          <div>
            <div class="ShowSelectSearch">
              <label>مبلغ را وارد کنید</label>
              <input
                class="InputX"
                type="text"
                inputmode="numeric"
                placeholder="0"
                v-model="front_show.credit"
                @input="(event) => setformatPrice(event, 'credit')"
                style="direction: ltr"
              />

              <div class="ShowDollarName">
                {{ $store.state.c_set.currency }}
              </div>
            </div>

            <div class="ButtonShowSelectSearch1" @click="BtnCharge">
              افزایش اعتبار
            </div>
          </div>
        </div>
      </div>
      <div class="walletImageConatiner">
        <div class="walletBanner">
          <img src="../assets/img/walletvector.png" alt="" />
        </div>
        <div class="walletDesc">
          <p v-for="(v,i) in $store.state.c_set.wallet_desc" :key="i" class="moreInfo">
            <span class="moreInfoIcon"></span>
            {{ v }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from "vue3-toastify";

export default {
  name: "creditUser",
  data() {
    return {
      optionUser: "",
      userBox: "",

      post_filds: {
        credit: 0,
      },
      front_show: {
        credit: 0,
      },

      SearchList1: [],
      setState: "",
      time: "",
      text: "اعتبار شما کافی نمی باشد",
      PageShow1: 0,
    };
  },

  mounted() {
    this.getCustomerinfo();
    this.mountedTestHandler();
  },
  methods: {
    mountedTestHandler() {
      console.log("tariff-single-list")
    },
    getCustomerinfo() {
      let self = this;
      this.helperPost("current-user-info").then((r) => {
        if (r.data.result == "1") {
          self.$store.commit("setAuth", r.data);
          self.$store.dispatch("checkAuth");
        }
      });
    },
    ShowMoneyToUSer(value) {
      this.post_filds.credit = value;
      this.front_show.credit = this.formatPrice(value);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(",", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    setformatPrice(event, param) {
      this.front_show[param] = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.post_filds[param] = event.target.value.replace(/[^\d.-]/g, "");
    },

    async BtnCharge() {
      const minPrice = Number(this.$store.state.c_set.wallet_defult_price[0] || '100000');
      if (this.post_filds.credit < minPrice) {
        toast(`حداقل اعتبار افزایشی ${this.formatPrice(minPrice)} تومان می باشد`, {
          type: "error",
          dangerouslyHTMLString: true,
        });
        this.text = "مبلغ مورد نظر را وارد کنید";
        return;
      }
      var price = this.post_filds.credit;

      if (this.credit == "") {
        this.text = "مبلغ مورد نظر را وارد کنید";
      } else {
        this.$swal
          .fire({
            title: "اتصال به درگاه",
            text:
              "افزایش اعتبار به مبلغ" + " " + this.formatPrice(price) + " تومان",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#0096c7",
            cancelButtonColor: "#fff",
            confirmButtonText: "تایید",
            cancelButtonText: "انصراف",
          })
          .then((result) => {
            if (result.isConfirmed) {
              if (result.value) {
                let self = this;
                this.helperPost("charge-credit", { amount: price })
                  .then((r) => {
                    if (r.data.result == 1) {
                      let link = r.data.data.url;
                      window.open(link, "_blank");
                    }
                  })
                  .catch(function () {
                    self.loading = false;
                  });
              }
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ShowCartRadiosRial1Scrollbar {
  width: 82%;
  margin: 32px auto 76px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  & > div {
    width: 48%;
  }

  .walletImageConatiner {
    display: flex;
    flex-direction: column;

    .walletBanner {
      display: flex;
      justify-content: center;
      margin-bottom: 24px;
      img {
        width: 76%;
      }
    }

    .walletDesc {
      .moreInfo {
        display: flex;
        gap: 8px;
        align-items: flex-start;
        font-size: 0.85rem;
        line-height: 1.45;
        text-align: justify;

        &:not(:last-of-type) {
          margin-bottom: 20px;
        }

        .moreInfoIcon {
          display: inline-block;
          width: 12px;
          height: 12px;
          flex-shrink: 0;
          border-radius: 50%;
          background: #0096c7;
          margin-top: 4px;
        }
      }
    }
  }
}

@media screen and (max-width: 700px) {
  .ShowCartRadiosRial1Scrollbar {
    width: 98%;
    flex-direction: column;
    gap: 48px;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 92px;

    & > div {
      width: 100%;
    }

    .walletImageConatiner {
      width: 90%;
      margin-inline: auto;
      .walletBanner {
        display: none;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
